/** @jsxImportSource @emotion/react */
import { PrimaryButton } from "../../../components/Buttons";
import { colors } from "../../../components/colors";
import { useFormContext } from "react-hook-form";
import {
  DeliveryRuleForm,
  Rule,
} from "../../../service/api-response/DeliveryRule";
import { css } from "@emotion/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { ButtonAction } from "../../../components/NewButtons";

type Props = {
  isEdit: boolean;
  onSubmit: (data: DeliveryRuleForm) => Promise<void>;
  isLoading: boolean;
  append: (value: Rule) => void;
  fields: Rule[];
};

export const DeliveryRulesFooter = ({
  isEdit,
  onSubmit,
  isLoading,
  fields,
  append,
}: Props) => {
  const { handleSubmit } = useFormContext<DeliveryRuleForm>();

  const buttonsStyle = css`
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: ${fields.length === 0 ? "end" : "space-between"};
    align-items: center;
    padding: 24px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 50%);
    border-radius: 0px 0px 4px 4px;
  `;

  return (
    <div css={buttonsStyle}>
      {fields.length !== 0 && (
        <PrimaryButton
          color={colors.textPrimary}
          backgroundColor={colors.transparent}
          hoverColor={colors.ctaLight}
          type="button"
          onClick={() =>
            append({
              minimumDistance: 0,
              maximumDistance: 0,
              productId: "",
            })
          }
        >
          + Add rule
        </PrimaryButton>
      )}
      <ButtonAction
        disabled={isLoading}
        type="button"
        onClick={handleSubmit(onSubmit)}
      >
        {isLoading ? (
          <FontAwesomeIcon icon={solid("spinner")} pulse spin />
        ) : (
          `${isEdit ? "Save" : "Create delivery rule group"}`
        )}
      </ButtonAction>
    </div>
  );
};
